export default __webpack_public_path__ + "static/media/07_photo.11c1be8d.jpg";